import React from 'react'
import { COMPANY_INFO } from '../lib/constants'

export default function FloatingCTA() {
  return (
    <div
      className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-3"
      role="region"
      aria-label="Hurtig kontakt"
    >
      {/* Email Button */}
      <a
        href={`mailto:${COMPANY_INFO.email}`}
        aria-label={`Send e-mail til ${COMPANY_INFO.email}`}
        title={`Send e-mail til ${COMPANY_INFO.email}`}
        className="group relative w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#252A6E] hover:bg-[#1D2158] text-white flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-300 ease-in-out hover:scale-110 active:scale-95 focus:outline-none focus:ring-2 focus:ring-[#252A6E] focus:ring-offset-2 border border-[#3C449E]/50"
      >
        <i
          className="fa-solid fa-envelope text-lg sm:text-xl transition-transform duration-300 group-hover:-translate-y-0.5"
          aria-hidden="true"
        />
        {/* Tooltip on hover */}
        <span className="hidden sm:block absolute right-full mr-3 px-3 py-1.5 bg-[#16182A] border border-[#252B66]/60 text-white text-xs font-semibold rounded-lg shadow-md whitespace-nowrap opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200">
          Send e-mail
        </span>
      </a>

      {/* Phone Button */}
      <a
        href={`tel:${COMPANY_INFO.phoneRaw}`}
        aria-label={`Ring til Jakob: ${COMPANY_INFO.phone}`}
        title={`Ring til Jakob: ${COMPANY_INFO.phone}`}
        className="group relative w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#E36C0A] hover:bg-[#B95000] text-white flex items-center justify-center shadow-lg hover:shadow-2xl transition-all duration-300 ease-in-out hover:scale-110 active:scale-95 focus:outline-none focus:ring-2 focus:ring-[#E36C0A] focus:ring-offset-2"
      >
        <i
          className="fa-solid fa-phone text-lg sm:text-xl transition-transform duration-300 group-hover:rotate-12"
          aria-hidden="true"
        />
        {/* Tooltip on hover */}
        <span className="hidden sm:block absolute right-full mr-3 px-3 py-1.5 bg-[#18191D] text-white text-xs font-semibold rounded-lg shadow-md whitespace-nowrap opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200">
          Ring: {COMPANY_INFO.phone}
        </span>
      </a>
    </div>
  )
}
